import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

const PaymentSuccessComponent = (props) => (
  <Box>
    <Container>
      <Typography variant="h5">
        SUCCESS
      </Typography>
      {
          props.order.ordTrackingNumber
            ? (
              <Typography variant="body1">
                Please save this tracking number for any future reference:
                {' '}
                <b>{props.order.ordTrackingNumber}</b>
                <br />
                We will update you in next 15 min regarding the status of your order.
              </Typography>
            )
            : (
              <Typography variant="body1">
                Thank you
              </Typography>
            )
          }
    </Container>
  </Box>
);

export default PaymentSuccessComponent;
